// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.feature-article-content[data-v-2766eeeb] {\n    position: relative;\n}\n.feature-article-left[data-v-2766eeeb] {\n    position: absolute;\n    left: -35px;\n    z-index: 1;\n}\n.feature-article-right[data-v-2766eeeb] {\n    position: absolute;\n    right: -35px;\n    z-index: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
